<template>
  <section>
    <team-intro></team-intro>
    <timer-bar></timer-bar>
    <team-cards></team-cards>
    <team-footer></team-footer>
    
  </section>
</template>

<script>
import TeamIntro from "@/components/TeamProfits/TeamIntro";
import TimerBar from "@/components/TeamProfits/TimerBar";
import TeamCards from "@/components/TeamProfits/TeamCards";
import TeamFooter from "@/components/Shared/TeamFooter";


export default {
  components: {
    TeamIntro,
    TimerBar,
    TeamCards,
    TeamFooter,
  },
  
};
</script>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 30px;
}
</style>